module.exports = function () {
    return window;
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex-web/src/$window.js
// module id = 557
// module chunks = 40